import { render, staticRenderFns } from "./consumables.vue?vue&type=template&id=e5a13dc0&scoped=true"
import script from "./consumables.vue?vue&type=script&lang=js"
export * from "./consumables.vue?vue&type=script&lang=js"
import style0 from "./consumables.vue?vue&type=style&index=0&id=e5a13dc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a13dc0",
  null
  
)

export default component.exports